import {PgaSdk} from "../sdk";
import {refreshAuthToken} from "./safe-refresh-token";
import {TOKEN_KEY} from "./constants";
import {isTokenExpired} from "./authProvider";


if (!import.meta.env.VITE_PUBLIC_SELF_DOMAIN) {
  console.warn("No VITE_PUBLIC_SELF_DOMAIN found in environment");
}

const ignoreEndpoints = new Set(["/api/v1/auth/email/login"]);
export const ApiSdk = new PgaSdk({
  BASE: import.meta.env.VITE_PUBLIC_BACKEND_API_BASE_URL,
  TOKEN: async (apiRequestOptions): Promise<string> => {
    let token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      return "";
    }
    const isExpired = isTokenExpired(token);

    const isIgnoredRefreshTokenPath = ignoreEndpoints.has(
        apiRequestOptions.url,
    );
    if (isExpired && !isIgnoredRefreshTokenPath) {
      try {
        await refreshAuthToken();
        token = localStorage.getItem(TOKEN_KEY);
      } catch (error) {
        console.error(error);
      }
    }

    console.log("Setting server session in API SDK");
    return token || "";
  },
  HEADERS: async () => {
    return {
      "x-application": "CPG-ADMIN",
      "x-application-domain": import.meta.env.VITE_PUBLIC_SELF_DOMAIN!,
    };
  },
});
